import { useMutation, useQuery } from "react-query";
import {
  addPurchaseInvoice,
  getPurchaseInvoice,
  getPurchaseInvoices,
  Http_GET_PurchaseInvoices,
  payPurchaseInvoice,
} from "./service";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";
import { AxiosError } from "axios";
import { Form_Create_PurchaseInvoice } from "../../../form/pembelian/add/Form";
import { Form_Update_PurchaseInvoice } from "../../../form/pembelian/belumLunas/Form";

export const useGetPurchaseInvoices = ({
  end_date,
  keyword,
  page,
  payment_method_id,
  perPage,
  start_date,
  status,
  supplier_id,
}: Http_GET_PurchaseInvoices) => {
  return useQuery({
    queryKey: [
      "invoice-purchase",
      end_date,
      keyword,
      page,
      payment_method_id,
      perPage,
      start_date,
      status,
      supplier_id,
    ],
    queryFn: () =>
      getPurchaseInvoices({
        end_date,
        keyword,
        page,
        payment_method_id,
        perPage,
        start_date,
        status,
        supplier_id,
      }),
  });
};

export const useGetPurchaseInvoice = ({
  purchase_invoice_id,
}: {
  purchase_invoice_id?: string;
}) => {
  return useQuery({
    enabled: purchase_invoice_id !== undefined,
    queryKey: ["purchase-detail-invoice", purchase_invoice_id],
    queryFn: () => getPurchaseInvoice({ purchase_invoice_id }),
  });
};

export const usePayPurchaseInvoice = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: ["pay-purchase-invoice"],
    mutationFn: ({
      payment_method_id,
      purchase_invoice_id,
    }: Form_Update_PurchaseInvoice) =>
      payPurchaseInvoice({ payment_method_id, purchase_invoice_id }),
    onSuccess: (e) => {
      showToast("Berhasil melakukan pembayaran invoice");
      redirect("/invoice/pembelian");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useAddPurchaseInvoice = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: ["addPurchaseInvoice"],
    mutationFn: ({
      payment_method_id,
      product_list,
      purchase_invoice_date,
      purchase_invoice_status,
      supplier_id,
      payment_due_date,
    }: Form_Create_PurchaseInvoice) =>
      addPurchaseInvoice({
        payment_method_id,
        product_list,
        purchase_invoice_date,
        purchase_invoice_status,
        supplier_id,
        payment_due_date,
      }),
    onSuccess: (e) => {
      showToast("Berhasil membuat pembelian invoice");
      redirect("/invoice/pembelian");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
